import React, { FC, useCallback, useEffect, useRef, useState } from "react";
import { Flex, FlexSpan, palette, Tooltip } from "@evergis/ui";
import { BarChartMarshalledGroup } from "@evergis/charts";

import { BarChart } from "./styled";

export const ChartPlaceholder: FC<{ error?: boolean }> = ({ error }) => {
  const [highlightIndex, setHighlightIndex] = useState<number>(0);
  const interval = useRef<number>(null);

  const customXAxis = useCallback(xAxis => {
    xAxis.remove();
  }, []);

  const customYAxis = useCallback(yAxis => {
    yAxis.remove();
  }, []);

  const customBars = useCallback(({ bars }) => {
    bars.attr("rx", 1).attr("ry", 1);
  }, []);

  const marshalledMap = useCallback(
    items => {
      return items.map(([item]: BarChartMarshalledGroup[], index) => {
        return [
          {
            ...item,
            color: index === highlightIndex ? "rgba(255, 255, 255, 0.5)" : item.color,
          },
        ];
      });
    },
    [highlightIndex],
  );

  const renderChart = useCallback(() => {
    return (
      <Flex style={{ position: "relative" }}>
        <FlexSpan>
          <BarChart
            colors={{ value: palette.elementDark }}
            width={72}
            height={24}
            data={[
              { groupName: "", 0: { value: 10 } },
              { groupName: "", 0: { value: 20 } },
              { groupName: "", 0: { value: 25 } },
              { groupName: "", 0: { value: 40 } },
              { groupName: "", 0: { value: 15 } },
              { groupName: "", 0: { value: 10 } },
              { groupName: "", 0: { value: 30 } },
              { groupName: "", 0: { value: 35 } },
              { groupName: "", 0: { value: 50 } },
              { groupName: "", 0: { value: 45 } },
              { groupName: "", 0: { value: 35 } },
              { groupName: "", 0: { value: 20 } },
            ]}
            customXAxis={customXAxis}
            customYAxis={customYAxis}
            xAxisPadding={0}
            yAxisPadding={0}
            customBars={customBars}
            barWidth={4}
            margin={{
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
            }}
          />
        </FlexSpan>
        <FlexSpan style={{ position: "absolute" }}>
          <BarChart
            colors={{ value: "rgba(255, 255, 255, 0.2)" }}
            width={72}
            height={24}
            data={[
              { groupName: "", 0: { value: 10 } },
              { groupName: "", 0: { value: 20 } },
              { groupName: "", 0: { value: 25 } },
              { groupName: "", 0: { value: 40 } },
              { groupName: "", 0: { value: 15 } },
              { groupName: "", 0: { value: 10 } },
              { groupName: "", 0: { value: 30 } },
              { groupName: "", 0: { value: 35 } },
              { groupName: "", 0: { value: 50 } },
              { groupName: "", 0: { value: 45 } },
              { groupName: "", 0: { value: 35 } },
              { groupName: "", 0: { value: 20 } },
            ]}
            customXAxis={customXAxis}
            customYAxis={customYAxis}
            xAxisPadding={0}
            yAxisPadding={0}
            customBars={customBars}
            marshalledMap={marshalledMap}
            barWidth={4}
            margin={{
              top: 0,
              left: 0,
              bottom: 0,
              right: 0,
            }}
          />
        </FlexSpan>
      </Flex>
    );
  }, [customBars, customXAxis, customYAxis, marshalledMap]);

  useEffect(() => {
    if (error) {
      window.clearInterval(interval.current);
      setHighlightIndex(-1);
    }
  }, [error]);

  useEffect(() => {
    interval.current = window.setInterval(() => {
      setHighlightIndex(prevState => (prevState < 12 ? prevState + 1 : 0));
    }, 45);

    return () => {
      window.clearInterval(interval.current);
    };
  }, []);

  return error ? (
    <Tooltip content="Не удалось получить данные">
      {ref => (
        <Flex style={{ width: "4.5rem", height: "1.5rem" }} ref={ref}>
          {renderChart()}
        </Flex>
      )}
    </Tooltip>
  ) : (
    <Flex style={{ width: "4.5rem", height: "1.5rem" }}>{renderChart()}</Flex>
  );
};
